/****/
export const GET_CRS_RISK_INDICATORS = 'GET_CRS_RISK_INDICATORS';
export const GET_CRS_RISK_INDICATORS_SUCCESS =
  'GET_CRS_RISK_INDICATORS_SUCCESS';
export const GET_CRS_RISK_INDICATORS_FAIL = 'GET_CRS_RISK_INDICATORS_FAIL';
/****/

/****/
export const GET_CRS_RISK_INDICATOR_THRESHOLDS =
  'GET_CRS_RISK_INDICATOR_THRESHOLDS';
export const GET_CRS_RISK_INDICATOR_THRESHOLDS_SUCCESS =
  'GET_CRS_RISK_INDICATOR_THRESHOLDS_SUCCESS';
export const GET_CRS_RISK_INDICATOR_THRESHOLDS_FAIL =
  'GET_CRS_RISK_INDICATOR_THRESHOLDS_FAIL';
/****/

/****/
export const PUT_CRS_RISK_INDICATOR_THRESHOLD =
  'PUT_CRS_RISK_INDICATOR_THRESHOLD';
export const PUT_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS =
  'PUT_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS';
export const PUT_CRS_RISK_INDICATOR_THRESHOLD_FAIL =
  'PUT_CRS_RISK_INDICATOR_THRESHOLD_FAIL';
/****/

/****/
export const DELETE_CRS_RISK_INDICATOR_THRESHOLD =
  'DELETE_CRS_RISK_INDICATOR_THRESHOLD';
export const DELETE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS =
  'DELETE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS';
export const DELETE_CRS_RISK_INDICATOR_THRESHOLD_FAIL =
  'DELETE_CRS_RISK_INDICATOR_THRESHOLD_FAIL';
/****/

/****/
export const UPDATE_CRS_RISK_INDICATOR_THRESHOLD =
  'UPDATE_CRS_RISK_INDICATOR_THRESHOLD';
export const UPDATE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS =
  'UPDATE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS';
export const UPDATE_CRS_RISK_INDICATOR_THRESHOLD_FAIL =
  'UPDATE_CRS_RISK_INDICATOR_THRESHOLD_FAIL';
/****/

/****/
export const POST_RISK_INDICATOR_TRIGGER = 'POST_RISK_INDICATOR_TRIGGER';
export const POST_RISK_INDICATOR_TRIGGER_SUCCESS =
  'POST_RISK_INDICATOR_TRIGGER_SUCCESS';
export const POST_RISK_INDICATOR_TRIGGER_FAIL =
  'POST_RISK_INDICATOR_TRIGGER_FAIL';
/****/

/****/
export const GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES =
  'GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES';
export const GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_SUCCESS =
  'GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_SUCCESS';
export const GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_FAIL =
  'GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_FAIL';
/****/

export function getRiskIndicatorsData(payload, status) {
  const cpObject = {
    getData: {
      type: GET_CRS_RISK_INDICATORS,
      payload
    },
    getFailData: {
      type: GET_CRS_RISK_INDICATORS_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_RISK_INDICATORS_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function getRiskIndicatorThresholdsData(payload, status) {
  const cpObject = {
    getData: {
      type: GET_CRS_RISK_INDICATOR_THRESHOLDS,
      payload
    },
    getFailData: {
      type: GET_CRS_RISK_INDICATOR_THRESHOLDS_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_RISK_INDICATOR_THRESHOLDS_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function putRiskIndicatorThresholdData(payload, status) {
  const cpObject = {
    getData: {
      type: PUT_CRS_RISK_INDICATOR_THRESHOLD,
      payload
    },
    getFailData: {
      type: PUT_CRS_RISK_INDICATOR_THRESHOLD_FAIL,
      payload
    },
    getSuccessData: {
      type: PUT_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function deleteRiskIndicatorThresholdData(payload, status) {
  const cpObject = {
    getData: {
      type: DELETE_CRS_RISK_INDICATOR_THRESHOLD,
      payload
    },
    getFailData: {
      type: DELETE_CRS_RISK_INDICATOR_THRESHOLD_FAIL,
      payload
    },
    getSuccessData: {
      type: DELETE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function updateRiskIndicatorThresholdData(payload, status) {
  const cpObject = {
    getData: {
      type: UPDATE_CRS_RISK_INDICATOR_THRESHOLD,
      payload
    },
    getFailData: {
      type: UPDATE_CRS_RISK_INDICATOR_THRESHOLD_FAIL,
      payload
    },
    getSuccessData: {
      type: UPDATE_CRS_RISK_INDICATOR_THRESHOLD_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function postRiskIndicatorTriggerScoring(payload, status) {
  const cpObject = {
    getData: {
      type: POST_RISK_INDICATOR_TRIGGER,
      payload
    },
    getFailData: {
      type: POST_RISK_INDICATOR_TRIGGER_FAIL,
      payload
    },
    getSuccessData: {
      type: POST_RISK_INDICATOR_TRIGGER_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function getRiskIndicatorStaticProperties(payload, status) {
  const cpObject = {
    getData: {
      type: GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES,
      payload
    },
    getFailData: {
      type: GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}
